(() => {
  const PREVIEW_CLASS = 'dc-cart-upload-preview';
  const STYLE_ID = 'dc-cart-upload-preview-styles';
  const NECKLACE_HANDLES = new Set([
    '/products/utrecht-ketting-langwerpige-domtoren-hanger',
    '/products/ovale-utrecht-domtoren-ketting'
  ]);
  const BEECH_HANDLES = new Set([
    '/products/utrecht-domtoren-plank-beuken-rond-20',
    '/products/utrecht-domtoren-plank-beuken-rond-20-gefreesde-rand',
    '/products/utrecht-domtoren-plank-beuken-rond-30',
    '/products/utrecht-domtoren-plank-beuken-33x14',
    '/products/utrecht-domtoren-plank-beuken-40x12',
    '/products/utrecht-domtoren-plank-beuken-44x20'
  ]);

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .dc-cart-upload-preview-link{display:block;width:min(140px,100%);margin-top:.35rem;text-decoration:none!important}
      .dc-cart-upload-preview{display:block;width:100%;height:auto;max-height:180px;object-fit:contain;border:1px solid rgba(0,0,0,.08);border-radius:8px;background:#f7f7f7}
      .dc-wallet-rear-preview{margin-top:.8rem;padding:.75rem;border:1px solid rgba(53,88,65,.16);border-radius:10px;background:#f7faf6}
      .dc-wallet-rear-preview img{display:block;width:100%;height:auto;max-height:310px;object-fit:contain;border-radius:8px;background:#fff}
      .dc-wallet-rear-preview__footer{display:flex;align-items:center;justify-content:space-between;gap:.8rem;margin-top:.65rem;font-size:.72rem}
      .dc-wallet-rear-preview__remove{border:0;background:transparent;color:#355841;font:inherit;font-weight:650;text-decoration:underline;cursor:pointer}
      .dc-necklace-coordinate-field{grid-column:1/-1}
    `;
    document.head.appendChild(style);
  }

  function enhanceRow(row) {
    if (!(row instanceof HTMLElement)) return;

    for (const property of row.querySelectorAll('.cart-items__property, .product-details__item')) {
      const label = property.querySelector('dt')?.textContent?.replace(/\s+/g, ' ').trim().toLowerCase() || '';
      if (!label.startsWith('foto')) continue;

      const link = property.querySelector('dd a[href*="/uploads/"]');
      if (!(link instanceof HTMLAnchorElement) || link.querySelector(`.${PREVIEW_CLASS}`)) continue;

      const filename = link.textContent?.trim() || 'Geüploade foto';
      const image = document.createElement('img');
      image.className = PREVIEW_CLASS;
      image.src = link.href;
      image.alt = 'Geüploade personalisatiefoto';
      image.loading = 'lazy';
      image.decoding = 'async';

      image.addEventListener('error', () => {
        link.classList.remove('dc-cart-upload-preview-link');
        link.textContent = filename;
      }, { once: true });

      link.textContent = '';
      link.classList.add('dc-cart-upload-preview-link');
      link.setAttribute('aria-label', 'Open de geüploade foto');
      link.appendChild(image);
    }
  }

  function enhance(root = document) {
    ensureStyles();

    if (root instanceof Element) {
      if (root.matches('.cart-items__table-row')) enhanceRow(root);
      const parentRow = root.closest('.cart-items__table-row');
      if (parentRow) enhanceRow(parentRow);
    }

    root.querySelectorAll?.('.cart-items__table-row').forEach(enhanceRow);
  }

  function refreshCartPreviews() {
    requestAnimationFrame(() => enhance(document));
    window.setTimeout(() => enhance(document), 80);
    window.setTimeout(() => enhance(document), 260);
  }

  function installDrawerCancelHandling(root = document) {
    root.querySelectorAll?.('theme-drawer > dialog.theme-drawer__dialog').forEach((panel) => {
      if (!(panel instanceof HTMLDialogElement) || panel.dataset.dcAndroidBackHandled === 'true') return;
      panel.dataset.dcAndroidBackHandled = 'true';

      panel.addEventListener('cancel', (event) => {
        const drawer = panel.parentElement;
        if (!(drawer instanceof HTMLElement) || drawer.tagName.toLowerCase() !== 'theme-drawer') return;
        if (!drawer.hasAttribute('open') || typeof drawer.close !== 'function') return;

        event.preventDefault();
        drawer.close();
      });
    });
  }

  function setupPhotoKeychainGate(root = document) {
    const boxes = [];
    if (root instanceof Element && root.matches('domstad-personalization[data-special="foto-sleutelhanger"]')) {
      boxes.push(root);
    }
    root.querySelectorAll?.('domstad-personalization[data-special="foto-sleutelhanger"]').forEach((box) => boxes.push(box));

    boxes.forEach((box) => {
      if (!(box instanceof HTMLElement)) return;
      const section = box.querySelector('.dc-personalization__photo');
      if (!(section instanceof HTMLElement)) return;

      const choiceWrap = section.querySelector('.dc-personalization__photo-choice');
      const choice = choiceWrap?.querySelector('select[name="properties[Fotobewerking]"]');
      const uploadBox = section.querySelector('.dc-personalization__upload-box');
      const uploadMeta = section.querySelector('.dc-personalization__upload-meta');
      const file = section.querySelector('input[type="file"][name="properties[Foto]"]');
      const header = section.querySelector('.dc-personalization__header');
      const title = header?.querySelector('.dc-personalization__title');
      const intro = header?.querySelector('.dc-personalization__intro');

      if (!(choiceWrap instanceof HTMLElement) || !(choice instanceof HTMLSelectElement) || !(uploadBox instanceof HTMLElement) || !(file instanceof HTMLInputElement)) return;

      if (title) title.textContent = 'Kies de fotobewerking en upload je foto';
      if (intro) intro.textContent = 'Kies eerst hoe je de foto wilt laten verwerken. Daarna kun je de foto uploaden voor de gravure.';

      if (choiceWrap.nextElementSibling !== uploadBox) {
        section.insertBefore(choiceWrap, uploadBox);
      }
      choiceWrap.style.marginTop = '0';
      choiceWrap.style.marginBottom = '1rem';

      let gateNote = section.querySelector('[data-dc-photo-gate-note]');
      if (!(gateNote instanceof HTMLElement)) {
        gateNote = document.createElement('p');
        gateNote.className = 'dc-personalization__upload-meta';
        gateNote.dataset.dcPhotoGateNote = '';
        choiceWrap.insertAdjacentElement('afterend', gateNote);
      }

      const update = () => {
        const hasChoice = Boolean(choice.value);
        const active = !box.hidden;
        const canUpload = active && hasChoice;

        file.disabled = !canUpload;
        uploadBox.hidden = !hasChoice;
        if (uploadMeta instanceof HTMLElement) uploadMeta.hidden = !hasChoice;
        gateNote.hidden = hasChoice;
        gateNote.textContent = 'Kies eerst hoe je de foto wilt laten verwerken. Daarna verschijnt de foto-upload.';
      };

      if (choice.dataset.dcPhotoGateBound !== 'true') {
        choice.dataset.dcPhotoGateBound = 'true';
        choice.addEventListener('change', update);
        file.addEventListener('click', (event) => {
          if (choice.value) return;
          event.preventDefault();
          choice.focus();
        });

        const disabledObserver = new MutationObserver(() => {
          if (!choice.value && !file.disabled) file.disabled = true;
        });
        disabledObserver.observe(file, { attributes: true, attributeFilter: ['disabled'] });
      }

      update();
    });
  }

  function setupWalletRearPhoto(root = document) {
    const boxes = [];
    if (root instanceof Element && root.matches('domstad-personalization[data-special="portemonneekaart"]')) boxes.push(root);
    root.querySelectorAll?.('domstad-personalization[data-special="portemonneekaart"]').forEach((box) => boxes.push(box));

    boxes.forEach((box) => {
      if (!(box instanceof HTMLElement) || box.dataset.dcWalletRearReady === 'true') return;
      const section = box.querySelector('[data-dc-photo-wrapper]');
      const lift = section?.querySelector('[data-upload-lift]');
      const uploadBox = lift?.closest('.dc-personalization__upload-box');
      const processing = section?.querySelector('select[data-dc-photo-processing]');
      const choiceWrap = processing?.closest('.dc-personalization__photo-choice');
      if (!(section instanceof HTMLElement) || !(lift instanceof HTMLElement) || !(uploadBox instanceof HTMLElement) || !(processing instanceof HTMLSelectElement) || !(choiceWrap instanceof HTMLElement)) return;

      box.dataset.dcWalletRearReady = 'true';
      uploadBox.style.padding = '1rem';
      lift.replaceChildren();

      const label = document.createElement('label');
      label.className = 'dc-personalization__label';
      label.innerHTML = 'Kies foto voor de achterkant <span>*</span>';

      const file = document.createElement('input');
      file.type = 'file';
      file.name = 'properties[Foto achterkant]';
      file.accept = '.jpg,.jpeg,.png,image/jpeg,image/png';
      file.className = 'dc-personalization__input';
      file.dataset.dcWalletRearPhoto = '';
      file.dataset.dcRequiredPhoto = '';
      file.disabled = true;
      label.htmlFor = `${box.id}-rear-photo`;
      file.id = `${box.id}-rear-photo`;

      const preview = document.createElement('div');
      preview.className = 'dc-wallet-rear-preview';
      preview.hidden = true;
      const image = document.createElement('img');
      image.alt = 'Voorbeeld van de foto voor de achterkant van je portemonneekaart';
      const footer = document.createElement('div');
      footer.className = 'dc-wallet-rear-preview__footer';
      const filename = document.createElement('strong');
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'dc-wallet-rear-preview__remove';
      remove.textContent = 'Verwijderen';
      footer.append(filename, remove);
      preview.append(image, footer);
      lift.append(label, file, preview);

      if (choiceWrap.nextElementSibling !== uploadBox) section.insertBefore(choiceWrap, uploadBox);
      choiceWrap.style.marginTop = '0';
      choiceWrap.style.marginBottom = '1rem';

      let note = section.querySelector('[data-dc-wallet-photo-gate-note]');
      if (!(note instanceof HTMLElement)) {
        note = document.createElement('p');
        note.className = 'dc-personalization__upload-meta';
        note.dataset.dcWalletPhotoGateNote = '';
        choiceWrap.insertAdjacentElement('afterend', note);
      }

      let previewUrl = '';
      const clearPreview = () => {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        previewUrl = '';
        image.removeAttribute('src');
        filename.textContent = '';
        preview.hidden = true;
      };

      file.addEventListener('change', () => {
        file.setCustomValidity('');
        const selected = file.files?.[0];
        if (!selected) {
          clearPreview();
          return;
        }
        if (selected.size > 10 * 1024 * 1024) {
          file.value = '';
          clearPreview();
          file.setCustomValidity('Kies een JPG, JPEG of PNG van maximaal 10 MB.');
          file.reportValidity();
          return;
        }
        clearPreview();
        previewUrl = URL.createObjectURL(selected);
        image.src = previewUrl;
        filename.textContent = selected.name;
        preview.hidden = false;
      });

      remove.addEventListener('click', () => {
        file.value = '';
        file.setCustomValidity('');
        clearPreview();
        file.dispatchEvent(new Event('change', { bubbles: true }));
      });

      const update = () => {
        const active = !box.hidden && !section.hidden;
        const hasChoice = Boolean(processing.value);
        const canUpload = active && hasChoice;
        processing.required = active;
        file.disabled = !canUpload;
        file.required = canUpload;
        uploadBox.hidden = !hasChoice;
        note.hidden = !active || hasChoice;
        note.textContent = 'Kies eerst hoe je de foto wilt laten verwerken. Daarna verschijnt de foto-upload.';
      };

      processing.addEventListener('change', update);
      const observer = new MutationObserver(update);
      observer.observe(box, { attributes: true, attributeFilter: ['hidden'] });
      observer.observe(section, { attributes: true, attributeFilter: ['hidden'] });
      update();
    });
  }

  function setupNecklaceCoordinates(root = document) {
    const path = window.location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '').replace(/\/$/, '');
    if (!NECKLACE_HANDLES.has(path)) return;

    const boxes = [];
    if (root instanceof Element && root.matches('domstad-personalization')) boxes.push(root);
    root.querySelectorAll?.('domstad-personalization').forEach((box) => boxes.push(box));

    boxes.forEach((box) => {
      if (!(box instanceof HTMLElement) || box.dataset.dcNecklaceCoordinatesReady === 'true') return;
      const form = box.closest('form');
      const fields = box.querySelector('.dc-personalization__fields');
      const line1 = box.querySelector('input[name="properties[Regel 1]"]');
      if (!(form instanceof HTMLFormElement) || !(fields instanceof HTMLElement) || !(line1 instanceof HTMLInputElement)) return;

      box.dataset.dcNecklaceCoordinatesReady = 'true';
      line1.required = false;
      const line1Label = line1.closest('.dc-personalization__field')?.querySelector('.dc-personalization__label');
      if (line1Label) line1Label.innerHTML = 'Regel 1 <small>optioneel als je een locatie invult</small>';

      const field = document.createElement('div');
      field.className = 'dc-personalization__field dc-necklace-coordinate-field';
      const label = document.createElement('label');
      label.className = 'dc-personalization__label';
      label.htmlFor = `${box.id}-coordinates-location`;
      label.innerHTML = 'Adres of locatie voor coördinaten <small>optioneel als je tekst invult</small>';
      const input = document.createElement('input');
      input.id = `${box.id}-coordinates-location`;
      input.className = 'dc-personalization__input';
      input.type = 'text';
      input.name = 'properties[Adres of locatie voor coördinaten]';
      input.placeholder = 'Bijvoorbeeld: Domplein, Utrecht';
      input.autocomplete = 'off';
      input.disabled = box.hidden;
      const meta = document.createElement('div');
      meta.className = 'dc-personalization__meta';
      meta.innerHTML = '<span>Domstad Cadeaus zet de locatie om naar coördinaten voor de gravure.</span>';
      field.append(label, input, meta);
      fields.append(field);

      const intro = box.querySelector('.dc-personalization__intro');
      if (intro) intro.textContent = 'Vul maximaal drie korte tekstregels in, of geef een adres of locatie op. Wij kunnen die locatie omzetten naar coördinaten voor de gravure.';

      const validate = () => {
        const active = !box.hidden;
        line1.required = false;
        input.disabled = !active;
        if (!active) {
          line1.setCustomValidity('');
          input.setCustomValidity('');
          input.value = '';
          return true;
        }
        const valid = Boolean(line1.value.trim() || input.value.trim());
        line1.setCustomValidity(valid ? '' : 'Vul regel 1 in of geef een adres of locatie op voor coördinaten.');
        input.setCustomValidity('');
        return valid;
      };

      line1.addEventListener('input', validate);
      input.addEventListener('input', validate);
      form.addEventListener('submit', (event) => {
        if (validate()) return;
        event.preventDefault();
        line1.reportValidity();
      }, true);

      const observer = new MutationObserver(validate);
      observer.observe(box, { attributes: true, attributeFilter: ['hidden'] });
      validate();
    });
  }

  function replaceText(root, replacements) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue || !node.nodeValue.trim()) continue;
      let value = node.nodeValue;
      for (const [from, to] of replacements) value = value.split(from).join(to);
      if (value !== node.nodeValue) node.nodeValue = value;
    }
  }

  function fixStructuredData(replacements) {
    document.querySelectorAll('script[type="application/ld+json"]').forEach((script) => {
      let value = script.textContent || '';
      for (const [from, to] of replacements) value = value.split(from).join(to);
      if (value !== script.textContent) script.textContent = value;
    });
  }

  function clarifyBeechPersonalization() {
    const path = window.location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '').replace(/\/$/, '');
    if (!BEECH_HANDLES.has(path)) return;
    document.querySelectorAll('domstad-personalization').forEach((box) => {
      if (!(box instanceof HTMLElement) || box.dataset.dcBeechCopyReady === 'true') return;
      const intro = box.querySelector('.dc-personalization__intro');
      const line1 = box.querySelector('label[for$="-line1"]');
      const line2 = box.querySelector('label[for$="-line2"]');
      if (!intro && !line1 && !line2) return;
      if (intro) intro.textContent = 'De vaste Utrecht-gravure staat op de voorkant. Je persoonlijke tekst wordt op de achterkant gegraveerd, met maximaal 2 regels van 20 tekens inclusief spaties per regel.';
      if (line1) line1.innerHTML = 'Regel 1 achterkant <span>*</span>';
      if (line2) line2.innerHTML = 'Regel 2 achterkant <small>optioneel</small>';
      box.dataset.dcBeechCopyReady = 'true';
    });
  }

  function applyStorefrontConsistencyFixes() {
    const localeMatch = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?=\/)/i);
    const localePrefix = localeMatch ? `/${localeMatch[1]}` : '';
    const personalisedLabel = localePrefix === '/en' ? 'Personalised gifts' : localePrefix === '/de' ? 'Personalisierte Geschenke' : 'Gepersonaliseerde cadeaus';
    const path = window.location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '').replace(/\/$/, '');

    if (path === '/pages/verzending') {
      const replacements = [
        ['Gratis vanaf €75', 'Gratis vanaf €100'],
        ['Bestellingen vanaf €75', 'Bestellingen vanaf €100'],
        ['Nederland vanaf €75:', 'Nederland vanaf €100:'],
        ['Vanaf €75 is verzending binnen Nederland gratis.', 'Vanaf €100 is verzending binnen Nederland gratis.'],
        ['€12,95', '€13,95'],
        ['tarief zichtbaar tijdens het afrekenen of op aanvraag', '€13,95'],
        ['Meestal 2 tot 5 werkdagen verwerking', 'Productietijd staat bij het product'],
        ['Bestellingen worden meestal binnen 2 tot 5 werkdagen verwerkt. Daarna wordt je pakket verzonden met track & trace.', 'De productietijd staat bij het product. Na productie wordt je pakket zorgvuldig verpakt en verzonden.'],
        ['Je bestelling wordt meestal binnen 2 tot 5 werkdagen verwerkt en daarna verzonden. Bij gepersonaliseerde producten kan dit iets langer duren.', 'De productietijd staat bij het product en verschilt per uitvoering. Daarna wordt je bestelling verzonden.'],
        ['België en Duitsland: meestal 2 tot 4 werkdagen bezorging na verzending', 'België: meestal 1 tot 2 werkdagen bezorging na verzending. Duitsland: meestal 2 tot 3 werkdagen bezorging na verzending.'],
        ['België en Duitsland:', 'België en Duitsland:'],
        ['Ja, verzending naar België en Duitsland is mogelijk. Hiervoor rekenen wij €13,95 verzendkosten.', 'Ja. België en Duitsland vallen onder het EU-tarief van €13,95 per bestelling.'],
        ['Andere EU-landen:', 'Andere EU-landen:']
      ];
      replaceText(document.body, replacements);
      fixStructuredData(replacements);
    }

    if (path === '/pages/contact') replaceText(document.body, [['4252 GD Vianen', '4131 GD Vianen']]);

    if (path === '/pages/retourbeleid') {
      document.querySelectorAll('a[href$="/collections/gepersonaliseerde-utrecht-cadeaus"]').forEach((link) => {
        link.href = `${localePrefix}/collections/gepersonaliseerde-cadeaus`;
        link.textContent = personalisedLabel;
      });

      const replacements = [
        ['Gepersonaliseerde producten die speciaal voor jou zijn gemaakt, kunnen meestal niet worden herroepen.', 'Voor producten die daadwerkelijk volgens jouw specificaties worden gemaakt kan de wettelijke maatwerkuitzondering op het herroepingsrecht gelden.'],
        ['Producten met naam, datum, persoonlijke tekst, eigen ontwerp, specifieke gravure of maatwerk vallen niet onder het gewone herroepingsrecht, behalve bij schade, defect of verkeerde levering.', 'De maatwerkuitzondering geldt alleen voor een uitvoering die daadwerkelijk volgens jouw specificaties is gemaakt. Een standaarduitvoering van een product dat ook gepersonaliseerd kan worden, houdt het gewone herroepingsrecht. Je wettelijke rechten bij schade, een defect of verkeerde levering blijven bestaan.'],
        ['Gepersonaliseerde producten kunnen niet worden geretourneerd.', 'Voor producten die daadwerkelijk volgens jouw specificaties worden gemaakt kan de wettelijke maatwerkuitzondering gelden.'],
        ['Gepersonaliseerde producten zijn uitgesloten van retour.', 'Voor producten die daadwerkelijk volgens jouw specificaties worden gemaakt kan de wettelijke maatwerkuitzondering gelden.'],
        ['Je ontvangt van ons een bevestiging, de retourinstructies en het juiste retouradres.', 'Je ontvangt van ons een bevestiging en retourinstructies. Het retouradres is Domstad Cadeaus, Vijfheerenlanden 350a, 4131 GD Vianen, Nederland.']
      ];
      replaceText(document.body, replacements);
      fixStructuredData(replacements);
    }
  }

  function applyPageEnhancements() {
    clarifyBeechPersonalization();
    applyStorefrontConsistencyFixes();
    setupPhotoKeychainGate(document);
    setupWalletRearPhoto(document);
    setupNecklaceCoordinates(document);
    installDrawerCancelHandling(document);
  }

  function start() {
    enhance();
    applyPageEnhancements();

    document.addEventListener('theme-drawer:open', (event) => {
      if (event.target instanceof HTMLElement && event.target.id === 'cart-drawer') refreshCartPreviews();
    });

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          enhance(node);
          setupPhotoKeychainGate(node);
          setupWalletRearPhoto(node);
          setupNecklaceCoordinates(node);
          installDrawerCancelHandling(node);
        }
      }
      clarifyBeechPersonalization();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    if (customElements.get('theme-drawer')) installDrawerCancelHandling(document);
    else customElements.whenDefined('theme-drawer').then(() => installDrawerCancelHandling(document));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
